import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../CloseButton/CloseButtonContainer';
import Loading from '../Loading/LoadingView';
import WhatIfsSectionView from '../WhatIfsSection/WhatIfsSectionContainer';
import AllPlanEditsCount from '../AllPlanEditsCount/AllPlanEditsCountContainer';

const CHANGE_FIELDS = ['fpId', 'goalId', 'clientId', 'url', 'selectedInsuranceType'];

class WhatIfMenuView extends Component {
  componentDidMount() {
    const { fetchData, clientId, fpId, goalData, url, goalId } = this.props;
    const { DebtType } = goalData;

    fetchData(clientId, fpId, goalId, url, DebtType);
  }

  componentDidUpdate(prevProps) {
    const { fetchData, clientId, fpId, goalData, url, goalId } = this.props;
    const { DebtType } = goalData;

    if (
      CHANGE_FIELDS.some(field => prevProps[field] !== this.props[field]) ||
      DebtType !== prevProps.goalData.DebtType
    ) {
      fetchData(clientId, fpId, goalId, url, DebtType);
    }
  }

  render() {
    const {
      clientId,
      fpId,
      goalData,
      url,
      loading,
      removeWhatIf,
      whatIfsSections,
      goalId,
    } = this.props;

    const { DebtType } = goalData;
    return (
      <div className="what-ifs-layout" role="dialog">
        {loading && <Loading />}
        <div
          className="what-ifs-menu  what-ifs-section what-ifs-layout-header"
          tabIndex={-1}
          id="what-ifs-container"
        >
          <h3>What-If...</h3>
        </div>
        <AllPlanEditsCount clientId={clientId} />
        <ul className="what-ifs-menu what-ifs-layout-content">
          {Object.keys(whatIfsSections).map(key => {
            const section = whatIfsSections[key] || [];

            if (section.length === 0) {
              return null;
            }

            return (
              <WhatIfsSectionView
                key={key}
                clientId={clientId}
                sectionId={key}
                sectionTitle={key.split(/(?=[A-Z])/).join(' ')}
                whatIfs={section.map(whatIf => ({
                  id: whatIf.WhatIf.WhatIfType,
                  question: whatIf.Title,
                  isApplied: whatIf.IsApplied,
                  onRemove: removeWhatIf(clientId, fpId, goalId, url, whatIf, DebtType),
                  name: whatIf.WhatIf.WhatIfTypeName,
                }))}
              />
            );
          })}
        </ul>
        <CloseButton clientId={clientId} className="what-ifs-menu-layout-footer" />
      </div>
    );
  }
}

WhatIfMenuView.propTypes = {
  loading: PropTypes.bool.isRequired,
  whatIfsSections: PropTypes.shape({}).isRequired,
  clientId: PropTypes.oneOfType(PropTypes.string, PropTypes.number).isRequired,
  fpId: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  removeWhatIf: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  goalData: PropTypes.shape({
    DebtType: PropTypes.string,
  }).isRequired,
  goalId: PropTypes.number.isRequired,
};

export default WhatIfMenuView;
